<template>
  <div>
    <div :class="`custom-card custom-card-${this.type}`">
      <div class="left-icon-btn" @click="displaySubTab = !displaySubTab">
        <i class="fa" :class="displaySubTab ? 'fa-minus' : 'fa-plus'"></i>
      </div>

      <div class="card-data">
        <div class="card-column">
          <span>{{ coachs.length }}</span>

          <span>Coachs</span>
        </div>

        <div class="card-column">
          <span>{{ averageAssignedAttributionsRatio }}%</span>

          <span>Attributions Attribuées</span>
        </div>
      </div>
    </div>

    <div v-if="displaySubTab" :class="`subtab subtab-${this.type}`">
      <el-table :data="coachsSorted" max-height="400">
        <el-table-column label="Nom" prop="name" width="180" sortable>
          <template slot-scope="scope">
            <span class="user-link" @click="(e) => goToCoach(e, scope.row.id)">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          label="Département"
          prop="zipcode"
          width="120"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row?.zipcode?.substring(0, 2) }}
          </template>
        </el-table-column>

        <el-table-column
          label="Nombres d'attributions attribuées"
          prop="totalAttributionsAttributed"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.totalAttributionsAttributed }}
          </template>
        </el-table-column>

        <el-table-column
          label="Nombres d'attributions acceptées"
          prop="totalAttributionsAccepted"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.totalAttributionsAccepted }}
          </template>
        </el-table-column>

        <el-table-column
          label="Nombres d'attributions refusées"
          prop="totalAttributionsRejected"
          sortable
        >
          <template slot-scope="scope">
            <PopoverRejectedReasons :coach-stats="scope.row">
              <template>{{ scope.row.totalAttributionsRejected }}</template>

              <template slot="fallback">{{
                scope.row.totalAttributionsRejected
              }}</template>
            </PopoverRejectedReasons>
          </template>
        </el-table-column>

        <el-table-column
          label="Ration d'attributions attribuées/refusées"
          prop="ratio"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.ratio }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import PopoverRejectedReasons from "@/components/coach-manager/attributions-treated/PopoverRejectedReasons";

export default {
  components: {
    PopoverRejectedReasons,
  },

  props: {
    coachs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      displaySubTab: false,
    };
  },

  computed: {
    coachsSorted() {
      const sorted = [...this.coachs];

      sorted.sort((a, b) => {
        if (a.ratio !== b.ratio) {
          return b.ratio - a.ratio;
        }

        if (a.totalAttributionsAttributed !== b.totalAttributionsAttributed) {
          return b.totalAttributionsAttributed - a.totalAttributionsAttributed;
        }

        return b.totalAttributionsRejected - a.totalAttributionsRejected;
      });

      return sorted;
    },

    averageAssignedAttributionsRatio() {
      if (this.coachs.length === 0) return 0;

      return (
        this.coachs.reduce((acc, coach) => {
          return acc + parseFloat(coach.ratio);
        }, 0) / this.coachs.length
      ).toFixed(2);
    },
  },

  methods: {
    goToCoach(e, id) {
      e.preventDefault();

      const route = this.$router.resolve({
        name: "user-details",
        params: { id },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
